import { useEffect, useState } from "react";
import { Camera } from "lucide-react";
import { queueCounts } from "../../lib/photoQueue";

/**
 * PhotoQueueBadge -- kleines Header-Element mit pending+uploading Count.
 * Pollt alle 3 Sekunden um Worker-Status widerzuspiegeln.
 */
export function PhotoQueueBadge({ className = "", testId = "photo-queue-badge", onClick }) {
    const [counts, setCounts] = useState({ active: 0, failed: 0 });

    useEffect(() => {
        let cancelled = false;
        const tick = async () => {
            try {
                const c = await queueCounts();
                if (!cancelled) setCounts({ active: c.active || 0, failed: c.failed || 0 });
            } catch (_e) { /* ignore */ }
        };
        tick();
        const iv = setInterval(tick, 3000);
        return () => {
            cancelled = true;
            clearInterval(iv);
        };
    }, []);

    if (!counts.active && !counts.failed) return null;

    return (
        <button
            type="button"
            onClick={onClick}
            className={`inline-flex items-center gap-1 rounded-full border border-border bg-card/60 px-2 py-1 text-xs text-foreground hover:border-primary ${className}`}
            data-testid={testId}
            aria-label="Foto-Queue"
        >
            <Camera className="h-3 w-3" />
            {counts.active > 0 ? (
                <span className="rounded bg-info/20 px-1 text-info">{counts.active}</span>
            ) : null}
            {counts.failed > 0 ? (
                <span className="rounded bg-destructive/20 px-1 text-destructive">
                    !{counts.failed}
                </span>
            ) : null}
        </button>
    );
}
